import Vue from 'vue'
import zh_CN from 'vee-validate/dist/locale/zh_CN';
import VeeValidate, { Validator } from 'vee-validate';

// 表单验证
Vue.use(VeeValidate, {
    useConstraintAttrs: true,
    //失去焦点时触发
    // events:"blur"
});
Validator.localize('zh_CN', zh_CN); // 本地化

//自定义验证url
Validator.extend("href",{
    validate:value=>{
        return /^(\/[\w-]+)+/.test(value)
    }
})
//自定义验证Number
Validator.extend("number",{
    validate:value =>{
        return /^(\d+\.)?\d+$/.test(value)
    }
})
//验证手机号
Validator.extend("mobile",{
    validate:value =>{
        return /^1[3,4,5,6,7,8]\d{9}$/.test(value)
    }
})
//验证固定电话以及传真
Validator.extend("fixedPhone",{
    validate:value =>{
        return /^0\d{2,3}-\d{7,8}(-\d{3})?$/.test(value)
    },
    getMessage:field => field +"格式不正确"
})
//    自定义提示语
const dictionary = {
    zh_CN: {
        messages: {
            required: (name) => `${name}不能为空!`,// name接受aliases(data-vv-as属性)的值.
            alpha_num:() => '只能包含字母和数字!',
            href:field =>field+"格式不正确",
            number:field => field +'必须是数值类型',
            mobile:field => field+ "格式不正确",
            numeric:field => field +"必须是整数",
        },
        /*attributes:{
            mobile:"手机号码"
        }*/
    }
};
Validator.localize(dictionary);
